import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import createApiClient from "../services/api";
import { Alert, Card, Spin, Button } from "antd";
import {
  CheckCircleOutlined,
  LoadingOutlined,
  DownloadOutlined,
  FileTextOutlined,
} from "@ant-design/icons";
import { fetchCurrentUser } from "../services/authAPI";
import { useAuth } from "../hooks/useAuth";

function PaymentSuccess() {
  const location = useLocation();
  const [sessionData, setSessionData] = useState(null);
  const [error, setError] = useState(null);
  const { setCurrentUser, setSelectedProject } = useAuth();
  const api = createApiClient();

  const updateUser = async () => {
    const user = await fetchCurrentUser();
    setSelectedProject(user.projects[0]);
    setCurrentUser(user);
    localStorage.setItem("user", JSON.stringify(user));
  };

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const sessionId = queryParams.get("session_id");

    if (sessionId) {
      api
        .get(`/subscriptions/checkout-session/${sessionId}`)
        .then((res) => {
          setSessionData(res.data);
        })
        .catch((err) => {
          setError(err.response?.data?.detail || "An error occurred.");
        })
        .finally(() => {
          updateUser();
        });
    }
  }, [location.search]);

  if (error) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
        <Alert
          message="Error"
          description={error}
          type="error"
          showIcon
          className="max-w-lg w-full"
        />
      </div>
    );
  }

  if (!sessionData) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <Spin
          indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />}
          tip="Loading..."
        />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <Card className="max-w-lg w-full shadow-lg">
        <div className="text-center mb-6">
          <CheckCircleOutlined className="text-green-500 text-5xl mb-4" />
          <h1 className="text-2xl font-bold text-gray-800">
            Payment Successful
          </h1>
        </div>

        <div className="space-y-4">
          <div className="border-b border-gray-200 pb-4">
            <p className="text-sm text-gray-500">Total Amount</p>
            <p className="text-base text-gray-800 font-medium">
              ${sessionData.amount_total / 100}
            </p>
          </div>

          <div className="border-b border-gray-200 pb-4">
            <p className="text-sm text-gray-500">Payment Status</p>
            <p className="text-base text-gray-800 font-medium capitalize">
              {sessionData.payment_status}
            </p>
          </div>

          <div className="border-b border-gray-200 pb-4">
            <p className="text-sm text-gray-500">Customer Email</p>
            <p className="text-base text-gray-800 font-medium">
              {sessionData.customer_email}
            </p>
          </div>

          <div className="pt-4">
            <p className="text-sm text-gray-500 mb-3">Invoice Actions</p>
            <div className="flex gap-3">
              <Button
                type="primary"
                icon={<FileTextOutlined />}
                href={sessionData.invoice_url}
                target="_blank"
              >
                View Invoice
              </Button>
              <Button
                icon={<DownloadOutlined />}
                href={sessionData.invoice_pdf}
                target="_blank"
              >
                Download PDF
              </Button>
            </div>
          </div>
        </div>
      </Card>
    </div>
  );
}

export default PaymentSuccess;
